module.exports = __webpack_public_path__ + "application/templates/default/partials/menu-mobile-bar.template.html";